import { z } from "zod";
import { avatarColorSchema } from "./avatar";

export const updateCompanySchema = z.object({
  name: z.string().min(1).max(255),
  color: avatarColorSchema,
  mailboxAdviceEmail: z.string().email().nullable().optional(),
});
export type UpdateCompany = z.infer<typeof updateCompanySchema>;
